import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { getFullApiUrl } from "../config";
import { setPodcastSession } from "../utils";

/** SPA 会话级缓存（按 token 键控：登录/登出后自动失效重查）。 */
let membershipCache = null; // { token, isMember }

/** 清除缓存（付费状态变化后调用，下次使用时重新校验）。 */
export function invalidateMembershipCache() {
  membershipCache = null;
}

/**
 * 会员状态：以服务端 user_payment_status 的 has_paid 为准，
 * 而不是以本地 podcast_session 是否存在来判断——会员过期后
 * session 记录仍在，但已无法通过 CDN 的实时校验。
 * 副作用：有效会员会同步最新 session 到本地；过期/未付费则清除
 * 本地失效 session，避免界面误显示会员态。
 */
export function useMembership() {
  const token = useSelector((state) => state.auth.token);
  const [state, setState] = useState(() =>
    membershipCache && membershipCache.token === token
      ? { isMember: membershipCache.isMember, ready: true }
      : { isMember: false, ready: !token }
  );

  useEffect(() => {
    if (!token) {
      membershipCache = null;
      setState({ isMember: false, ready: true });
      return undefined;
    }
    if (membershipCache && membershipCache.token === token) {
      setState({ isMember: membershipCache.isMember, ready: true });
      return undefined;
    }

    let cancelled = false;
    axios
      .get(getFullApiUrl("/api/v1/subscribe/user_payment_status"), {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const isMember = !!response.data?.has_paid;
        if (response.data?.podcast_session) {
          setPodcastSession(response.data.podcast_session);
        } else if (!isMember) {
          localStorage.removeItem("podcast_session");
        }
        membershipCache = { token, isMember };
        if (!cancelled) setState({ isMember, ready: true });
      })
      .catch((err) => {
        console.error("Failed to check membership:", err);
        if (!cancelled) setState({ isMember: false, ready: true });
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return state;
}
